import {Component, Build, Element, h, Listen, Prop, Watch} from '@stencil/core';

/**
 * @slot default - Use it to inject your `joy-step` items
 */
@Component({
    tag: 'joy-stepper',
    styleUrl: 'style/stepper.scss',
    shadow: true,
})
export class Stepper {
    @Element() host!: HTMLJoyStepperElement;

    /** Current step number. Starts from 1. */
    @Prop({reflect: true}) step!: number;
    /** Current sub step number. Starts from 1. Should be specified when the current step has sub steps. */
    @Prop({reflect: true}) subStep: number = 1;

    componentWillLoad() {
        this.checkStep();
        this.setCurrentItemSubStep();
    }

    // this method is called on load
    private handleSlotChange() {
        this.updateStepProps();
    }

    @Watch('step')
    private checkStep() {
        if (this.step <= 0 || this.step > this.steps.length) {
            console.warn('step must be positive and equal or lower than the number of joy-step elements');
        }
    }

    private setCurrentItemSubStep() {
        if (!this.currentStepItem) {
            return;
        }

        if (this.invalidSubStepValue()) {
            this.currentStepItem.currentSubStep = this.currentStepItem.subSteps;

            if (!Build.isTesting) {
                console.warn('subStep must be positive and equal or lower than current step subSteps');
            }
        } else {
            this.currentStepItem.currentSubStep = this.subStep;
        }
    }

    @Watch('step')
    @Watch('subStep')
    private updateStepProps() {
        this.steps.forEach(async (step, i) => {
            step.completed = i < this.step - 1;

            if (i === this.step - 1) {
                this.setCurrentItemSubStep();
            } else {
                step.currentSubStep = 0;
            }
        });
    }

    @Listen('joy-step-sub-steps-change')
    private listenSubStepsChange(event: CustomEvent) {
        event.stopPropagation();

        this.updateStepProps();
    }

    private invalidSubStepValue() {
        return this.currentStepItem && (this.subStep <= 0 || this.subStep > this.currentStepItem.subSteps);
    }

    get steps() {
        return Array.from(this.host.querySelectorAll('joy-step'));
    }

    get currentStepItem(): HTMLJoyStepElement | undefined {
        return this.steps[this.step - 1];
    }

    render() {
        return (
            <div class="joy-stepper">
                <slot onSlotchange={() => this.handleSlotChange()} />
            </div>
        );
    }
}
